module.exports = {
    SELECTORS: {
        registrationContainer: '.js-event-form-container',
        eventRegistrationForm: '.js-event-registration-form',
        eventMinorRegistrationForm: '.js-event-minor-form',
        eventAdultRegistrationForm: '.js-event-adult-form',
        checkUserForm: '.js-check-user-registration',
        eventSelected: '.js-event-card',
        formControl: 'input.js-form-control:not("#registration-form-phone"), textarea.js-form-control, select.js-select-validate',
        formsContainer: '.js-fe-forms-container',
        backButton: '.js-go-back',
        modalTitle: '.js-event-modal-title',
        modalHeader: '.js-event-modal-header',
        submitButton: '.js-check-user-submit',
        docuSignContainer: '#signing-ceremony',
        registrationCompleted: '.js-registration-completed',
        registrationRefused: '.js-registration-refused',
        registrationCompletedDetails: '.js-registration-completed-details',
        existingMinorRegistrations: '.js-existing-minor-subscriptions',
        fullEventModal: '.js-fe-event-modal',
        inviteFriendCheckbox: 'input[name="dwfrm_fullEvent_fullEvent_inviteFriend"]',
        inviteFriendFields: '.js-invite-friend-field',
        inviteFriendInput: '.js-invited-friend-email',
        inviteFriendFname: '.js-invite-friend-fname',
        inviteFriendLname: '.js-invite-friend-lname',
        eventDetails: '.js-event-details',
        dataset: '.js-dataset-fe',
        openLoginAppEvent: '.js-fe-open-loginModal-app',
        minorCheckbox: '.js-minor-checkbox'
    },
    STAGES: {
        checkUser: 'checkUser',
        adultRegistration: 'adultRegistration',
        minorRegistration: 'minorRegistration',
        docuSign: 'docuSign',
        completed: 'registrationCompleted',
        refused: 'registrationRefused',
    }
};
